import { render, staticRenderFns } from "./OwnerShowContent.vue?vue&type=template&id=637674b0&scoped=true&"
import script from "./OwnerShowContent.vue?vue&type=script&lang=js&"
export * from "./OwnerShowContent.vue?vue&type=script&lang=js&"
import style0 from "./OwnerShowContent.vue?vue&type=style&index=0&id=637674b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637674b0",
  null
  
)

export default component.exports